import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as pdfjs from 'pdfjs-dist';
import workerSrc from 'pdfjs-dist/build/pdf.worker.js';
@Component({
  selector: 'iu-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
  standalone: true,
})
export default class PdfViewerComponent implements OnInit {
  @Input() dataUrl;
  @ViewChild('pdfViewer', { read: ElementRef, static: false }) pdfViewer: ElementRef<HTMLDivElement>;
  constructor() {}

  ngOnInit(): void {
    if (this.dataUrl) this.displayPdf(this.dataUrl);
  }

  async displayPdf(pdfDataUrl: string) {
    pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

    const loadingTask = pdfjs.getDocument(pdfDataUrl);
    const pdf = await loadingTask.promise;

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);

      const scale = window.devicePixelRatio + 1.5 || 2.5;
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.width = viewport.width;
      canvas.style.width = '100%';
      canvas.height = viewport.height;

      await page.render({
        canvasContext: context!,
        viewport,
      }).promise;

      this.pdfViewer.nativeElement.appendChild(canvas);
    }
  }
}
